import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/list/list.module.css
var css_248z = ".mantine-List-root .list-module_itemWrapper__9dvDt {\n    display: inline-flex;\n    align-items: stretch;\n    overflow-wrap: break-word;\n}\n\n.mantine-List-item[data-with-icon] .list-module_itemWrapper__9dvDt {\n    display: inline-flex;\n    align-items: center;\n}\n";
var list_module_default = { "itemWrapper": "list-module_itemWrapper__9dvDt" };
style_inject_es_default(css_248z);

//#endregion
export { list_module_default as default };